import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import LaptopSvg from '@shared/assets/svgs/laptop.svg';
import { Image } from '@src/components/Image';
import { SnippetSwiper } from '../SnippetSwiper';
import { PackagePreviewProps } from './props';
import './styles.scss';

export const PackagePreview: FC<PackagePreviewProps> = ({ isPremium }) => {
  const logoUrl = 'https://meetfrank-static-media.s3.amazonaws.com/images/acme-logo.jpg';
  const companyName = 'Acme Inc.';
  const salaryRange = '1500 - 3400€ / mo';

  return (
    <div className="package-preview">
      <div className="package-preview__header">
        <Image className="package-preview__header-logo" src={logoUrl} />
        <div className="package-preview__header-titles">
          <div className="package-preview__header-title">Senior Product Manager</div>
          <div className="package-preview__header-subtitle">{companyName}</div>
        </div>
      </div>

      <div className="package-preview__locations-salary">
        <div className="package-preview__locations-item">
          <div className="package-preview__locations-item-icon">
            <Svg src={LaptopSvg} />
          </div>
          <div className="package-preview__locations-label">Remote</div>
        </div>

        <div className="package-preview__salary-info">{salaryRange}</div>
      </div>

      {isPremium && <SnippetSwiper />}
    </div>
  );
};
